import styled from "styled-components";

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
`;

export const TableHead = styled.div`
  display: flex;
  align-items: center;
  background: #fafafa;
  border-top: 1px solid #f4f4f5;
  border-bottom: 1px solid #f4f4f5;
  min-width: 900px;
  min-height: 48px;
`;

export const HeadCell = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  flex: ${({ $flex }) => $flex || 1};
  min-width: 0;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  ${({ $sortable }) => $sortable && "cursor: pointer;"}
`;

export const SortIcon = styled.span`
  display: inline-flex;
  color: ${({ $active }) => ($active ? "#11a7d9" : "rgba(0, 0, 0, 0.25)")};
  transform: rotate(${({ $direction }) => ($direction === "desc" ? "180deg" : "0deg")});
`;

export const Row = styled.div`
  display: flex;
  align-items: stretch;
  min-width: 900px;

  &:hover {
    background: #fafbfc;
  }
`;

export const Cell = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 16px;
  flex: ${({ $flex }) => $flex || 1};
  min-width: 0;
  border-bottom: 1px solid #f4f4f5;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 22px;
`;

export const TagsCell = styled(Cell)`
  flex-wrap: wrap;
  gap: 6px;
`;

export const ServiceTag = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 1px 8px;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid #e4e4e7;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
`;

export const ActionsCell = styled(Cell)`
  justify-content: flex-end;
  gap: 8px;
`;

export const IconBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: none;
  border: none;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.65);

  &:hover {
    background: rgba(0, 0, 0, 0.04);
    color: #11a7d9;
  }
`;

export const ActionsMenu = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 240px;
  padding: 4px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

export const ActionsMenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  color: ${({ $danger }) => ($danger ? "#f5222d" : "rgba(0, 0, 0, 0.88)")};
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  white-space: nowrap;

  &:hover {
    background: ${({ $danger }) =>
      $danger ? "rgba(245, 34, 45, 0.06)" : "#f5f5f5"};
  }
`;
